import { Grid } from '@mui/material'
import { AuthLayout } from 'components'
import { AuthWrapper } from 'containers/Auth'
import { Faqs } from 'containers/Faqs'

export const FAQs: React.FC = () => {
  return (
    <AuthLayout>
      <AuthWrapper>
        <Grid container>
          <Grid item>
            <Faqs isAuthorized={false}/>
          </Grid>
        </Grid>
      </AuthWrapper>
    </AuthLayout>
  )
}
